import moduleDescriptions from 'root/src/shared/descriptions/modules'

import {
	bannerHeaderModuleDescriptionLenses,
} from 'root/src/client/logic/header/lenses'

const { pathOrBannerBoxImages } = bannerHeaderModuleDescriptionLenses

export default (state, { moduleId }) => pathOrBannerBoxImages(
	moduleId, [], moduleDescriptions,
)
